module.exports = __webpack_public_path__ + "9c642ae670bb37abb2693cd6c736641d.jpg";